import { Route } from 'react-router-dom';
import { USER_PERMISSIONS } from '@invento/shared';
import { PermissionGuard } from '@/navigation/guards/permission-guard';
import { lazyNamed } from '../lazy-named';
import { TenantPreviewRouteFrame } from './route-frames';

const loadTeam = () => import('@/features/team');
const TeamListPage = lazyNamed(loadTeam, 'TeamListPage');
const TeamMemberDetailPage = lazyNamed(loadTeam, 'TeamMemberDetailPage');

export function teamRoutes() {
  return (
    <Route element={<TenantPreviewRouteFrame />}>
      <Route
        path="team"
        element={
          <PermissionGuard required={USER_PERMISSIONS.READ}>
            <TeamListPage />
          </PermissionGuard>
        }
      />
      <Route
        path="team/:memberId"
        element={
          <PermissionGuard required={USER_PERMISSIONS.READ}>
            <TeamMemberDetailPage />
          </PermissionGuard>
        }
      />
    </Route>
  );
}
